var poll_default = {
  "fontElementMap": "daj0q",
  "container": "umNFt",
  "fullscreen": "UMp9q",
  "background_overlay": "YcrpG",
  "with_image": "YWeOe",
  "options": "Ytx-z",
  "webview": "OrlaM",
  "grid": "fn8m1",
  "option": "lI6y0",
  "cta_button": "KhnUc",
  "add_option": "XHE0e",
  "see_more": "F1Vut",
  "list": "qP686",
  "column": "n5U1j",
  "additional_note": "cYrzt",
  "spinner": "UyNdX",
  "spin": "S6OOT",
  "shown": "hgwY6",
  "error": "_73nxh"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
